<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="showState && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="showState && !$route.meta.keepAlive" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  data () {
    return {
      showState: true
    };
  },
  provide () {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload () {
      this.showState = false;
      this.$nextTick(() => {
        this.showState = true;
      });
    },


  },
  watch: {
    '$route': {
      handler: async function (val) {
        try {


        } catch (error) {
          console.log("error", error);
        }
      },
      deep: true,
      immediate: true
    },
    local: {
      handler (val) {



      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      local: state => state.local,
    }),
  },
  mounted () {
    this.$store.dispatch('getUserDetailsByIdHandle')

  }
};
</script>

<style lang="scss">
@import './styles/reset.css';
#app {
  width: 100%;
  height: 100%;
  & > div {
    width: 100%;
    height: 100%;
  }
}
.custom-popper {
  position: absolute !important;
  top: 50px !important;
  z-index: 999 !important;
}

.el-cascader__dropdown {
  position: absolute !important;
  top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue